/**
 * @file Text helpers shared by the debug surfaces.
 *
 * Every tuning layer derives its panel rows from a config table, which means
 * every one of them needs a readable label for a field nobody wrote a label for.
 * Four copies of the same three lines earn one shared helper.
 */

/**
 * @param {string} key camelCase identifier.
 * @returns {string} `maxHealth` -> `Max health`.
 */
export function humanise(key) {
  const spaced = key.replace(/([A-Z])/g, ' $1').toLowerCase();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
